import React from 'react';

const centerIframe = (container, offset) => {
  const iframe = container.querySelector('iframe');
  if (iframe) {
    iframe.style.display = 'block';
    iframe.style.margin = '0 auto';
    if (offset) iframe.style.transform = `translateX(-${offset})`;
  }
};

const TrustBox = ({ style, centered, centerOffset, data }) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const load = () => {
      window.Trustpilot.loadFromElement(ref.current, true);
      if (centered) centerIframe(ref.current, centerOffset);
    };
    if (window.Trustpilot) {
      load();
      return;
    }
    const interval = setInterval(() => {
      if (window.Trustpilot) {
        load();
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [centered]);

  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget" // Renamed this to className.
      style={style}
      {...data}
    >
      <a href="https://www.trustpilot.com/review/dynamicevents.ie" target="_blank" rel="noopener">
        {' '}
        Trustpilot
      </a>
    </div>
  );
};

export default TrustBox;
